/**
 * useArticles
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import ArticlesContext from './articles-context'

const useArticles = () => {
  const context = useContext(ArticlesContext)

  return context
}

export default useArticles
